<div id="orders" class="page-layout simple right-sidebar" fxLayout="row">

    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div style="padding: 20px;" class="header primary" fxLayout="column" fxLayoutAlign="center center"
            fxLayoutGap="20px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
            <span class="mat-display-1 my-0 my-sm-24 welcome-message"
                [@animate]="{value:'*',params:{x:'50px'}}">{{'DEVICE_LIST' | translate}}
            </span>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>

            <div fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button *ngIf="selection.selected.length>0" mat-raised-button matTooltip="{{'SEND_FIRMWARE_TO_ALL'|translate}}"
                        (click)="allChangeFirmwareUpdateCheck()">
                        <mat-icon>reply_all</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="addDevices()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="center">
            <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                [@animateStagger]="{value:'50'}">
<!-- 
                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front">
                        <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">
                        </div>
                        <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-52 line-height-52">
                                {{ devicesList.length ? devicesList.length :'0' }}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'DEVICES' | translate}}
                            </div>
                        </div>
                        <mat-progress-bar [fxShow]="tableLoading" mode="indeterminate">
                        </mat-progress-bar>
                    </div>

                </fuse-widget> -->

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="25">

                    <div class="fuse-widget-front">
                        
                        <div class="pt-48 pb-48" fxLayout="column" fxLayoutAlign="center center">
                            <div class="red-fg font-size-52 line-height-52">
                                {{selected.solar? selected.solar/100:"---"}}V
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'SOLAR_ENERGY_BATTERY'|translate}}
                            </div>
                        </div>
                        <mat-progress-bar [fxShow]="requestLoading" mode="indeterminate">
                        </mat-progress-bar>
                    </div>
                    
                </fuse-widget>


                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="25">

                    <div class="fuse-widget-front">

                        <div class="pt-48 pb-48" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-52 line-height-52">
                                {{selected.heat?selected.heat/10:"---"}}°C
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'CPU_HEAT'|translate}}
                            </div>
                        </div>
                        <mat-progress-bar [fxShow]="requestLoading" mode="indeterminate">
                        </mat-progress-bar>
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="25">

                    <div class="fuse-widget-front">

                        <div class="pt-48 pb-48" fxLayout="column" fxLayoutAlign="center center">
                            <div class="orange-fg font-size-52 line-height-52">
                                {{selected.battary?(selected.battary | deviceBattery | number : '1.0-0'):"---"}}%
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'BATTERY'|translate}}
                            </div>
                        </div>
                        <mat-progress-bar [fxShow]="requestLoading" mode="indeterminate">
                        </mat-progress-bar>
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="25">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 pb-48" fxLayout="column" fxLayoutAlign="center center" style="text-align: center;">
                            <div *ngIf="selected.mesafe!='-1'" class="purple-fg font-size-52 line-height-52">
                                {{selected?.mesafe?selected.mesafe:"---"}}%
                            </div>
                            <div *ngIf="selected.mesafe=='-1'" class="purple-fg font-size-28 line-height-32">
                                {{'NOT_CONTAINER'|translate}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'OCCUPANCY'|translate}}
                            </div>
                        </div>
                        <mat-progress-bar [fxShow]="requestLoading" mode="indeterminate">
                        </mat-progress-bar>
                    </div>

                </fuse-widget>

            </div>

        </div>
        <!-- / CONTENT -->

        <div class="content-card" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table mat-elevation-z8" style="border-radius: 10px 10px 0px 0px;" 
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" fusePerfectScrollbar>
                    
                    <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef>
                            <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'DEVICE'|translate}} {{'ID'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>{{device.id}}</p>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="model">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Model</mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>
                                {{device.model}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="firmware">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Firmware
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>
                                {{device.firmware}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="firmwareUpdateCheck">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{('FIRMWARE_UPDATE_CHECK'|translate)}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>
                                {{device.firmwareUpdateCheck==true?('UPDATING'|translate):'CURRENT'|translate}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="runType">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{('RUN_TYPE'|translate)}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <span *ngIf="device.runType==1">1-{{'RUN_TYPE_1'|translate}}</span>
                            <span *ngIf="device.runType==2">2-{{'RUN_TYPE_2'|translate}}</span>
                            <span *ngIf="device.runType==3">3-{{'RUN_TYPE_3'|translate}}</span>
                            <span *ngIf="device.runType==4">4-{{'RUN_TYPE_4'|translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Updated Column -->
                    <ng-container matColumnDef="updated">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'WILL_BE_UPDATED'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <mat-checkbox disabled [checked]="device.updated"></mat-checkbox>
                        </mat-cell>
                    </ng-container>

                    <!-- Time Column -->
                    <ng-container matColumnDef="deviceLatestStatus.sonBaglantiTarih">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'LAST_CONNECTION_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>
                                {{device.deviceLatestStatus ? (device.deviceLatestStatus.sonBaglantiTarih?(device.deviceLatestStatus.sonBaglantiTarih | date:'dd/MM/y HH:mm'):'---'):'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- update Column -->
                    <ng-container matColumnDef="udate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'UPDATED_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <p>
                                {{device.uDate?(device.uDate | date:'dd/MM/y HH:mm'):'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="companyId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            {{device?.companyId!=null?device.company.name:'---'}} 
                        </mat-cell>
                    </ng-container>

                    <!-- setting Column -->
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="updateDevices(device)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button *ngIf="companyId == 1" mat-menu-item (click)="updateCompanyDevices(device)">
                                    <mat-icon>account_balance</mat-icon>
                                    <span>{{'UPDATE_COMPANY'|translate}}</span>
                                </button>
                                <button *ngIf="roleId==-1" mat-menu-item (click)="changeFirmwareUpdateCheck(device)">
                                    <mat-icon>reply</mat-icon>
                                    <span>{{'SEND_FIRMWARE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="onDevicesMap(device)">
                                    <mat-icon>map</mat-icon>
                                    <span>{{'MAPS'|translate}}</span>
                                </button>
                                <button *ngIf="roleId==-1" [routerLink]="['/apps/devices/view']" [queryParams]="{ deviceId: device.id }"
                                    mat-menu-item>
                                    <mat-icon>info</mat-icon>
                                    <span>{{'DETAIL'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteDevices(device)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row [style.background]="highlightedRowss[device.id] ? '#1976d2' : ''"
                        *matRowDef="let device; columns: displayedColumns;" (click)="requestChange(device)"
                        class="order" matRipple>
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>